/*Clase Token, contiene credenciales y token para
  acceso a servicios de plexi-rest */
export class FileDTO{

        //constructor de la clase
        constructor(

          //Nombre archivo
          public nombre:string,

           //cadena respuestas
          public cadena:string,

          /**Guarda el archivo cargado	 */
	        public  archivo:any

){}
}
